import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BreakingTicker from "@/components/feature/BreakingTicker";
import BackToTop from "@/components/feature/BackToTop";
import JsonLd from "@/components/feature/JsonLd";
import HeroSection from "./components/HeroSection";
import LiveFeed from "./components/LiveFeed";
import FeaturedSection from "./components/FeaturedSection";
import CategoryGrid from "./components/CategoryGrid";
import FaqSection from "./components/FaqSection";
import CtaBand from "./components/CtaBand";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { getBreakingArticles, getHotArticles } from "@/utils/news";

function Home() {
  useDocumentMeta({
    title: "瓜圈速报 - 瓜圈速报刚刚｜突发爆料第一手快讯 最新进展抢先看",
    description:
      "瓜圈速报专注娱乐圈突发爆料与最新进展，瓜圈速报刚刚、瓜圈速报突发第一时间同步，提供第一手快讯与事件来龙去脉，最新进展抢先看。",
    keywords: "瓜圈速报,瓜圈速报刚刚,瓜圈速报突发,第一手快讯,最新进展抢先看",
    canonical: "https://hrbsnws.cn/",
  });

  const breaking = getBreakingArticles(5);
  const hotList = getHotArticles(5);

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: "瓜圈速报",
        url: "https://hrbsnws.cn/",
        description:
          "专注娱乐圈突发爆料与最新进展的速报资讯站，第一手快讯同步，最新进展抢先看。",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://hrbsnws.cn/category/all?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "Organization",
        name: "瓜圈速报",
        url: "https://hrbsnws.cn/",
        email: "hi@guaspeed.example.com",
        description: "把突发、最新进展与快讯集中同步的娱乐资讯编辑团队。",
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "瓜圈速报上的快讯多久更新一次？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "页面按发布时间倒序同步，正常情况下每天多次更新。遇到突发爆料，会先发一条简短快讯，再随着各方回应补充完整的时间线。",
            },
          },
          {
            "@type": "Question",
            name: "「突发」标签代表消息已经确认了吗？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "不完全是。突发只代表话题在短时间内快速发酵、讨论量大，具体事实仍要以当事人和官方回应为准。",
            },
          },
          {
            "@type": "Question",
            name: "后续回应和反转会同步吗？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "会。同一条速报会持续跟进，只要出现新的声明、澄清或进展，都会更新到详情页的时间线里。",
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <JsonLd data={jsonLd} />
      <SiteHeader />
      <main>
        <HeroSection lead={breaking[0]} hotList={hotList} />
        <BreakingTicker articles={breaking} />
        <LiveFeed />
        <FeaturedSection />
        <CategoryGrid />
        <FaqSection />
        <CtaBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}

export default Home;